<template>
  <div id="backdoor_home">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            開發人員後門專區
          </div>
          <div class="tip">
            僅 dev / staging 可用。新增工具時在 src/router/Backdoor.js 加一筆路由並設定 meta.backdoorTitle，即會出現在此清單
          </div>
        </div>
      </div>
      <div class="tool_list">
        <router-link
          v-for="tool in tools"
          :key="tool.name"
          class="tool_card"
          :to="{ name: tool.name }"
        >
          <div class="tool_card__title">
            {{ tool.title }}
          </div>
          <div class="tool_card__description">
            {{ tool.description }}
          </div>
          <div class="tool_card__path">
            /backdoor/{{ tool.path }}
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BackdoorHome',
  computed: {
    /**
     * 後門工具清單，取自 /backdoor/ 底下有設定 meta.backdoorTitle 的子路由
     */
    tools () {
      const backdoorRoute = this.$router.options.routes.find(route => route.path === '/backdoor/')
      if (!backdoorRoute || !backdoorRoute.children) return []
      return backdoorRoute.children
        .filter(route => route.meta && route.meta.backdoorTitle)
        .map(route => ({
          name: route.name,
          path: route.path,
          title: route.meta.backdoorTitle,
          description: route.meta.backdoorDescription || ''
        }))
    }
  }
}
</script>

<style lang="scss" scoped>
#backdoor_home {
  @include mainLayer();
  .title {
    font-weight: bold;
    font-size: 25px;
    margin-bottom: 10px;
    text-align: left;
  }
  .tip {
    text-align: left;
    color: #777;
  }
  .tool_list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 16px;
    margin-top: 24px;
    text-align: left;
  }
  .tool_card {
    display: block;
    padding: 16px 20px;
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    background: #fff;
    color: inherit;
    text-decoration: none;
    transition: border-color 0.2s, box-shadow 0.2s;
    &:hover {
      border-color: $mainColor;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    }
    &__title {
      font-weight: bold;
      font-size: 18px;
      margin-bottom: 8px;
    }
    &__description {
      color: #555;
      line-height: 1.5;
      margin-bottom: 8px;
    }
    &__path {
      font-family: Menlo, Consolas, monospace;
      font-size: 12px;
      color: #999;
    }
  }
}
</style>
